<style lang="scss">

.list-enter-active,
.list-leave-active {
  transition: transform 1s;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}

test, test:hover {
    text-decoration: none ! important;
    cursor: hand;
}

</style>

<template>
    <Content>
        <div class="page-header d-print-none mb-2">
            <div class="row align-items-center">
              <div class="col">
                <div class="page-pretitle">
                    Eingebunden
                </div>
                <h2 class="page-title">
                    Sensorik
                </h2>
              </div>
              
              <div class="col-auto ms-auto d-print-none">
                <div class="btn-list">
                    <span class="d-sm-inline">
                        <transition name="fade">
                            <select v-show="sensorList.length > 0" v-model="sortingType" class="form-select" title="Sensoren sortieren">
                                <option value="date">nach Aktualisierung</option>
                                <option value="alphabetical">alphabetisch</option>
                                <option value="onlyActive">nur aktive Sensoren</option>
                            </select>
                        </transition>
                    </span>
                    <button class="btn btn-info d-none d-sm-inline-block text-white" @click="openNewModal">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                        Neuen Sensor einbinden
                    </button>
                    <button class="btn btn-success d-sm-none btn-icon text-white bg-green" aria-label="" @click="openNewModal">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    </button>
                </div>
              </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12 mt-2 mb-0">
                <Alert type="info" :show="alertEmptySensorList" >
                    <template v-slot:title>Keine Sensoren eingebunden</template>
                    Es wurden noch keine Sensoren eingebunden. Um Sensorik in die Bewässerungs-App einzubinden, muss 
                    sie zuerst beim Anbieter eingerichtet werden. Nach dem Einrichten kann der Sensor unter "Erfassen" 
                    den entsprechenden Schlägen zugeordnet werden. Einen neuen Sensor können Sie rechts oben unter 
                    "Neuen Sensor einbinden" einbinden.
                </Alert>
            </div>
        </div>
        
        
        <div class="row">
            <div class="col-12 mt-2 mb-0">
                <Alert type="success" :show="alertNew" :timeout="12000">
                    <template v-slot:title>Neuer Sensor eingebunden</template>
                    In der Liste finden Sie den neu angelegten Sensor. Die Zuordnung zu einem Schlag können sie unter 
                        <router-link v-if="addedSensor.parameterId === 'n'" to="/precipitation" >Erfassen > Niederschlag</router-link>    
                        <router-link v-else to="/profiles" >Erfassen</router-link> 
                    vornehmen.
                </Alert>
            </div>
        </div>
        
         <div class="row">
            <div class="col-12 mt-2 mb-0">
              <Alert type="success" :show="alertAlter" :timeout="12000">
                <template v-slot:title>Sensor geändert</template>
                Die Änderungen am Sensor wurden vorgenommen.
                
              </Alert>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12">
                <div v-visible="loading" class="progress progress-sm mb-2">
                    <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
                </div>
                <div v-show="sensorListing.length > 0" class="card">
                    <div class="list-group list-group-flush list-group-hoverable">
                        <transition-group name="fade_" tag="div">
                            <div v-for="sensor in sensorListing" v-bind:key="sensor.id" class="list-group-item">
                                <SensorItem :sensor="sensor" isAdjustable="sensor.isOwnSensor" @adjustSensor="openAlterModal(sensor)" >
                                </SensorItem>
                            </div>
                        </transition-group>
                    </div>
                </div>       
            </div>
        </div>
    </Content>
   <NewSensor ref="newSensor" @add-sensor="addSensor" :key="modalKey"></NewSensor>
   <AlterSensor ref="alterSensor" :sensor="sensor" @alter-sensor="alterSensor" :key="modalKey"></AlterSensor>
</template>

<script>

import axios from 'axios';
import Content from '@/components/Content.vue';
import SensorItem from '@/components/sensor/SensorItem.vue';
import NewSensor from '@/components/sensor/NewSensor.vue';
import AlterSensor from '@/components/sensor/AlterSensor.vue';
import Alert from '@/components/Alert.vue';


export default {
    name: 'About',
    components: {
		Content,
        SensorItem,
        NewSensor,
        AlterSensor,
        Alert
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        select1sd: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            sensor: null,
            sensorList: [],
            sortingType: 'date',
            profileYearList: [],
            profilesByYear: [],
            year: 0,
            loading: false,
            alertNew: false,
            alertAlter: false,
            modalKey: 0,
            addedSensorId: null
        }
    },
    computed: {
        addedSensor: function() {
            return this.getListItemById(this.sensorList, this.addedSensorId);
        },
        alertEmptySensorList: function() {
            return this.loading === false && this.sensorList.length === 0;
        },
        sensorListing: function() {
            let sensorListing = this.sensorList.slice();
            const listingType = this.listing[this.sortingType];
            
            if ( listingType && listingType.sorting ) {
                sensorListing.sort(listingType.sorting);
            }
            
            if ( listingType && listingType.filtering ) {
                sensorListing = sensorListing.filter(listingType.filtering);
            }
            
            return sensorListing;
        }
    },
    methods: {
        openNewModal: function() {
            this.alertNew = false;
            this.alertAlter = false;
        
            this.modalKey = this.modalKey + 1;
            this.$nextTick(function() { 
                this.$refs.newSensor.openModal();
            });
        },
        openAlterModal: function(sensor) {
            this.alertNew = false;
            this.alertAlter = false;
            this.sensor = sensor;
        
            this.modalKey = this.modalKey + 1;
            this.$nextTick(function() { 
                this.$refs.alterSensor.openModal();
            });
        },
        alterSensor: function(sensor, callback) {
            const self = this;
            
            let query = {
                query: `
                mutation (
                    $sensorId: Int!
                    $label: String
                    $isImportActive: Boolean
                    $sharedUserIds: [String]
                ) {
                    alterSensor (
                        sensorId: $sensorId
                        label: $label
                        isImportActive: $isImportActive
                        sharedUserIds: $sharedUserIds
                    ) {
                        user {
                            sensors {
                                id
                                label
                                parameterId
                                labelParameter
                                userId
                                sharedUserIds
                                providerSensorId
                                isEmbedded
                                errors
                                lastUpdate
                                isOwnSensor
                                isUsed
                                isImportActive
                                sensorDataYears
                            }
                        }
                    }
                }
                `,      
                variables: sensor
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.sensorList = data.alterSensor.user.sensors;
                    self.alertAlter = true;
                });
             
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
           
        },
        addSensor: function(sensor, callback) {
            const self = this;
            
            self.$nextTick(function() { 
                self.$refs.newSensor.closeModal();
            });
            
            let query = {
                query: `
                mutation (
                    $providerId: String!
                    $providerSensorId: Int!
                    $label: String!
                    $isActive: Boolean
                    $sharedUserIds: [String]
                ) {
                    newSensor (
                        providerId: $providerId
                        providerSensorId: $providerSensorId
                        label: $label
                        isActive: $isActive
                        sharedUserIds: $sharedUserIds
                    ) {
                        user {
                            sensors {
                                id
                                label
                                parameterId
                                labelParameter
                                userId
                                sharedUserIds
                                providerSensorId
                                isEmbedded
                                errors
                                lastUpdate
                                isOwnSensor
                                isUsed
                                isImportActive
                                sensorDataYears
                            }
                        }
                        sensorId
                    }
                }
                `,      
                variables: sensor
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.sensorList = data.newSensor.user.sensors;
                    self.addedSensorId = data.newSensor.sensorId;
                    self.alertNew = true;
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
                
                
                if (callback) {
                    callback(self);
                }
            });
        },
        fetchSensors: function(callback) {

            const self = this;
            
            let query = {
                query: `
                query {
                    user {
                        sensors {
                            id
                            label
                            parameterId
                            labelParameter
                            userId
                            sharedUserIds
                            providerSensorId
                            isEmbedded
                            errors
                            lastUpdate
                            isOwnSensor
                            isUsed
                            isImportActive
                            sensorDataYears
                        }
                        loggedIn                        
                    }
                }     
                `,      
                variables: {
                
                }
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.sensorList = data.user.sensors;
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        },
        routeTo: function() {
            let path = '/';
            let query = {}; 
            let referrer = this.$route.query.referrer;
            
            if (referrer) {
                path = decodeURIComponent(referrer);
                return path;
            }
            
            return false;
        },
        isReferrer: function() {
            if (this.$route.query.referrer) {
                return true;
            }
            return false;
        },
        getListItemById: function(list, id) {
            return list.reduce( function(accumulator, currentValue) {
                if (currentValue.id === id) {
                    return currentValue;
                } else {
                    return accumulator;
                }
            }, {});
        }
    },
    watch: {
       
    },
    created: function()  {
        this.fetchSensors();
        this.listing = {
            date: { 
                sorting: function(a, b) {
                    if (a.lastUpdate > b.lastUpdate) {
                        return -1;
                    }
                    if (a.lastUpdate < b.lastUpdate) {
                        return 1;
                    }
                    return 0;
                }
            },
            alphabetical: { 
                sorting: function(a, b) {
                    if (a.label < b.label) {
                        return -1;
                    }
                    if (a.label > b.label) {
                        return 1;
                    }
                    return 0;
                }
            },
            onlyActive: {
                sorting: function(a, b) {
                    if (a.lastUpdate > b.lastUpdate) {
                        return -1;
                    }
                    if (a.lastUpdate < b.lastUpdate) {
                        return 1;
                    }
                    return 0;
                },
                filtering: function(a) {
                    return a.isImportActive;
                }
            },
        }
    }
}

</script>
